import { Backdrop, CircularProgress } from '@mui/material';
import { ILoader } from './type';

const Loader = (props: ILoader) => {
  const { open } = props;
  return (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
